import styled from 'styled-components'

export const CursorPoint = styled.div`
  cursor: pointer;
`
